import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text, Heading, Icon } from '../Elements';

import { months } from './helpers/configurates';
import {
  generateYears,
  lastYearDate,
  getFullMonthName,
  getSmallMonthName
} from './helpers/helpers';

import classes from './DatePickerMY.module.scss';

const years = generateYears();

const DatePickerMY = ({ onChange }) => {
  const [openPicker, setOpenPicker] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(lastYearDate().month);
  const [selectedYear, setSelectedYear] = useState(years[1]);
  const node = useRef();
  const buttonPicker = useRef();
  const { t } = useTranslation(['activity']);

  useEffect(() => {
    if (openPicker) {
      document.addEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [openPicker]);

  const handleClick = e => {
    if (
      node.current.contains(e.target) ||
      buttonPicker.current.contains(e.target)
    ) {
      return;
    }
    setOpenPicker(false);
  };

  const hanleOpenPicker = () => {
    setOpenPicker(!openPicker);
  };

  const handleMonth = month => {
    onChange(`${selectedYear}/${month}`);
    setSelectedMonth(month);
  };

  const handleYear = year => {
    if (
      Number(year) === Number(years[0]) &&
      Number(lastYearDate().month) === 1
    ) {
      onChange(`${lastYearDate().year}/${'12'}`);
      setSelectedMonth('12');
      setSelectedYear(lastYearDate().year);
    } else if (
      Number(year) === Number(years[0]) &&
      Number(selectedMonth) >= Number(lastYearDate().month)
    ) {
      onChange(`${year}/${months[Number(lastYearDate().month) - 2]}`);
      setSelectedMonth(months[Number(lastYearDate().month) - 2]);
      setSelectedYear(year);
    } else {
      onChange(`${year}/${selectedMonth}`);
      setSelectedYear(year);
    }
  };

  return (
    <div className={classes.pickerWrap}>
      <div ref={buttonPicker}>
        <Text onClick={hanleOpenPicker} className={classes.select}>
          {t('activity:filters.CHOOSE_DATES')}
          <Icon size="16px" icon={'arrow'} />
        </Text>
      </div>

      {openPicker && (
        <div className={classes.windowPicker} ref={node}>
          <div className={classes.windowPicker_arrow} />
          <Heading className={classes.currentDate}>
            {getFullMonthName(selectedMonth)} {selectedYear}
            <Icon
              size="16px"
              icon={'arrow'}
              className={classes.date_arrow}
              onClick={hanleOpenPicker}
            />
          </Heading>
          <div className={cn(classes.monthsWrap, classes.monthsWrap_line)}>
            {months.map(month => (
              <div
                key={month}
                className={cn(
                  classes.monthWrap,
                  month === selectedMonth && classes.selectedMonth
                )}
                onClick={
                  Number(selectedYear) === Number(years[0]) &&
                  Number(month) < Number(lastYearDate().month)
                    ? () => handleMonth(month)
                    : Number(selectedYear) < Number(years[0])
                    ? () => handleMonth(month)
                    : () => {}
                }
              >
                <Text
                  className={cn(
                    Number(selectedYear) === Number(years[0]) &&
                      Number(month) >= Number(lastYearDate().month)
                      ? classes.disabledYear
                      : Number(selectedYear) > Number(years[0])
                      ? classes.disabledYear
                      : ''
                  )}
                >
                  {getSmallMonthName(month)}
                </Text>
              </div>
            ))}
          </div>
          <div className={classes.monthsWrap}>
            {years.map(year => (
              <div
                key={year}
                className={cn(
                  classes.monthWrap,
                  year === selectedYear && classes.selectedMonth
                )}
                onClick={
                  Number(year) < 2017 ? () => {} : () => handleYear(year)
                }
              >
                <Text
                  className={cn(Number(year) < 2017 && classes.disabledYear)}
                >
                  {year}
                </Text>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

DatePickerMY.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default DatePickerMY;
